/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BucketDuration = "DAY" | "HOUR" | "MINUTE" | "MONTH" | "WEEK" | "YEAR" | "%future added value";
export type LabelingActivityChart_viewer = {
    readonly labelSummaryTimeBuckets: ReadonlyArray<{
        readonly duration: BucketDuration | null;
        readonly startTime: unknown;
        readonly perLabelerSummaries: ReadonlyArray<{
            readonly labeler: {
                readonly id: string;
                readonly username: string | null;
            };
            readonly summary: {
                readonly numPallets: number;
                readonly numItems: number | null;
            };
        } | null>;
    } | null> | null;
    readonly " $refType": "LabelingActivityChart_viewer";
};
export type LabelingActivityChart_viewer$data = LabelingActivityChart_viewer;
export type LabelingActivityChart_viewer$key = {
    readonly " $data"?: LabelingActivityChart_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"LabelingActivityChart_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "LabelingActivityChart_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "bucketDuration",
      "type": "BucketDuration",
      "defaultValue": "DAY"
    },
    {
      "kind": "LocalArgument",
      "name": "knownObjects",
      "type": "[KnownObject!]",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "numBuckets",
      "type": "Int",
      "defaultValue": 30
    },
    {
      "kind": "LocalArgument",
      "name": "startTime",
      "type": "DateTime",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "labelSummaryTimeBuckets",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "bucketDuration",
          "variableName": "bucketDuration"
        },
        {
          "kind": "Variable",
          "name": "knownObjects",
          "variableName": "knownObjects"
        },
        {
          "kind": "Variable",
          "name": "numBuckets",
          "variableName": "numBuckets"
        },
        {
          "kind": "Variable",
          "name": "startTime",
          "variableName": "startTime"
        }
      ],
      "concreteType": "LabelSummaryTimeBucket",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "duration",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "startTime",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "perLabelerSummaries",
          "storageKey": null,
          "args": null,
          "concreteType": "PerLabelerLabelSummary",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "labeler",
              "storageKey": null,
              "args": null,
              "concreteType": "LabelerUser",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "id",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "username",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "summary",
              "storageKey": null,
              "args": null,
              "concreteType": "LabelSummary",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "numPallets",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "numItems",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '274f17377baf15b2103a3491c55039ba';
export default node;
